import { FC, ReactElement } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks';
import { settingsActions } from 'store/slices/mapV2/mapReducer/settingsSlice';
import { typesSelector } from 'store/slices/mapV2/mapReducer/settingsSlice/selectors';

import { OpacitySlider } from 'components/OpacitySlider';
import { Switch } from 'components/ui';

export interface MapTypeElementProps {
  name: string;
  title: string;
  description: string;
  preview?: string;
  icon?: ReactElement;
  opacitySlider?: boolean;
  active: boolean;
  onSwitch: () => void;
}

const MapTypeElement: FC<MapTypeElementProps> = ({
  name,
  title,
  description,
  preview,
  icon,
  opacitySlider,
  active,
  onSwitch,
}) => {
  const mapTypes = useAppSelector(typesSelector);

  const dispatch = useAppDispatch();

  const handleOpacityChange = (opacity: number) => {
    const changedType = mapTypes[name];

    dispatch(
      settingsActions.setTypes({
        ...mapTypes,
        [name]: {
          ...changedType,
          opacity: opacity,
        },
      })
    );
  };

  return (
    <div>
      <div className="flex shrink-0 flex-row gap-4 w-full h-12">
        {preview && (
          <img
            src={preview}
            alt="image"
            className="min-w-12 h-12 rounded-[10px] bg-light"
          />
        )}
        {icon && (
          <div className="flex shrink-0 justify-center items-center w-12 h-12 rounded-[50%] bg-light text-tpg_base [&>svg]:w-8 [&>svg]:h-8">
            {icon}
          </div>
        )}
        <div className="flex flex-col justify-center items-start w-full">
          <div className="flex flex-row justify-between items-center w-full h-5">
            <p className="tpg-b2">{title}</p>
            <Switch checked={active} onChange={onSwitch} />
          </div>
          {active && opacitySlider ? (
            <OpacitySlider opacityCallback={handleOpacityChange} />
          ) : (
            <div>
              <p className="h-5 pt-2 tpg-c2 text-tpg_base">{description}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MapTypeElement;
